import { FC } from 'react';
import { Col } from 'antd';
import { Field } from 'react-final-form';
import { connect } from 'react-redux';
import i18next from 'i18next';

import { SectionBody, SectionHeader, SubSection } from '~src/shared/form/shared.sc';
import { validatorRequired } from '~src/services/validators';
import { AttributeI } from '~src/interfaces/attributes.types';
import { StoreI } from '~src/rootReducer';
import Checkbox from '~src/shared/form/Checkbox';
import { FieldType } from '~src/types';

import { AdditionalSelectProps } from './UserForm';

interface StateProps {
  timezones: { [key: string]: string };
  contentLocales: { [key: string]: string };
  systemLocales: { [key: string]: string };
}

interface OwnProps {
  t: i18next.TFunction;
  timezoneAttribute: AttributeI;
  systemLanguageAttribute: AttributeI;
  contentLanguageAttribute: AttributeI;
  renderSelectInput: (props: FieldType & AdditionalSelectProps) => JSX.Element;
  isOwnUser?: boolean | null;
}

type Props = StateProps & OwnProps;

const SettingsAttributeSection: FC<Props> = props => {
  const renderAdminCheckbox = (props: FieldType & { disabled: boolean }): JSX.Element => (
    <Checkbox
      id="check"
      label={props.label}
      labelKey={props.labelKey}
      val="admin"
      isChecked={props.input.checked}
      disabled={props.disabled}
      input={props.input}
    />
  );

  return (
    <>
      <SectionHeader data-translation="x.users.advanced">{props.t('x.users.advanced')}</SectionHeader>
      <SectionBody>
        <SubSection>
          <Col lg={8}>
            <Field
              name={`attributes.${props.timezoneAttribute.uuid}`}
              label={props.t('x.users.timezone')}
              component={props.renderSelectInput}
              list={props.timezones}
              validate={validatorRequired}
              translationKey="x.users.timezone"
            />
          </Col>

          <Col lg={8}>
            <Field
              name={`attributes.${props.systemLanguageAttribute.uuid}`}
              label={props.t('x.users.system_language')}
              component={props.renderSelectInput}
              list={props.systemLocales}
              validate={validatorRequired}
              translationKey="x.users.system_language"
            />
          </Col>
          <Col lg={8}>
            <Field
              name={`attributes.${props.contentLanguageAttribute.uuid}`}
              label={props.t('x.users.content_language')}
              component={props.renderSelectInput}
              list={props.contentLocales}
              validate={validatorRequired}
              translationKey="x.users.content_language"
            />
          </Col>
        </SubSection>
        <SubSection>
          <Col lg={24} style={{ paddingBottom: '1rem' }}>
            <Field
              name="permissions.admin"
              label={props.t('x.users.grant_admin_permissions')}
              labelKey={'x.users.grant_admin_permissions'}
              type="checkbox"
              component={renderAdminCheckbox}
              disabled={Boolean(props.isOwnUser)}
            />
          </Col>
        </SubSection>
      </SectionBody>
    </>
  );
};

const mapStateToProps = (state: StoreI): StateProps => ({
  contentLocales: state.user.session.contentLocales,
  systemLocales: state.user.session.systemLocales,
  timezones: state.user.session.timezones,
});

const SettingsAttributeSectionSuper = connect(mapStateToProps)(SettingsAttributeSection);

export default SettingsAttributeSectionSuper;
